import { Pencil, Trash2 } from "lucide-react";

const HEADERS = [
  "Contact Name",
  "Gender",
  "Email",
  "Phone",
  "Teams ID",
  "Position",
  "Active",
  "Actions",
];

const ActiveBadge = ({ active }) => (
  <span
    className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${
      active ? "bg-emerald-50 text-emerald-700" : "bg-gray-100 text-gray-600"
    }`}
  >
    {active ? "Yes" : "No"}
  </span>
);

const ContactPersonsTable = ({ persons = [], onEdit, onDelete, readOnly = false }) => {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden">
      <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
        <table className="w-full table-auto border-collapse min-w-[1100px]">
          <thead className="sticky top-0 z-10">
            <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
              {HEADERS.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-center font-semibold whitespace-nowrap"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {persons.length === 0 ? (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  className="py-10 text-center text-gray-400 text-xs"
                >
                  No contact persons found.
                </td>
              </tr>
            ) : (
              persons.map((contact, index) => {
                const rowBg = index % 2 === 0 ? "bg-gray-50" : "bg-white";
                const fullName = `${contact.first_name || ""} ${contact.last_name || ""}`.trim();
                return (
                  <tr
                    key={contact.id}
                    className={`${rowBg} hover:bg-brand-50 transition-colors`}
                  >
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-900">
                      {fullName || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700 capitalize">
                      {contact.gender || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center">
                      {contact.email ? (
                        <a
                          href={`mailto:${contact.email}`}
                          className="text-brand-600 hover:underline"
                        >
                          {contact.email}
                        </a>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {contact.phone || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {contact.teams_id || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700">
                      {contact.position || "—"}
                    </td>
                    <td className="px-3 py-2 text-xs whitespace-nowrap text-center">
                      <ActiveBadge active={contact.is_active} />
                    </td>
                    <td className="px-3 py-2 text-center whitespace-nowrap">
                      {contact.isPrimary || readOnly ? (
                        <span className="text-[10px] text-gray-400">—</span>
                      ) : (
                        <div className="flex justify-center gap-3">
                          <Pencil
                            className="w-4 h-4 text-brand-400 hover:text-brand-600 cursor-pointer transition-colors"
                            title="Edit"
                            onClick={() => onEdit?.(contact)}
                          />
                          <Trash2
                            className="w-4 h-4 text-danger-400 hover:text-danger-600 cursor-pointer transition-colors"
                            title="Delete"
                            onClick={() => onDelete?.(contact.id)}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactPersonsTable;
